import { createSvgIcon } from '@mui/material/utils';

export default createSvgIcon(
  <path d="M5 8h14l-7 11z"/>
, 'SortArrow');
